let cameraOrbitTempActive = false;

function initCameraOrbitToggle(controlsOrbit, controlsObjRot, LimitsCtl) {
    const controlsEmpty = {};

    let getCurrentSlideControlsType = () => {
        let slideControls = Q3.SlideManager.currentSlide.controls;
        if (!slideControls) return "orbit";

        return slideControls.interactionType || "orbit";
    };

    let isOrbiting = false;

    document.addEventListener("keydown", event => {
        if (LimitsCtl.isControlEvent(event)) {
            // event.preventDefault();
            if (getCurrentSlideControlsType() === 'objectRotation') {
                cameraOrbitTempActive = true;
                controlsObjRot.enabled = false;
                controlsOrbit.enabled = true;
                LimitsCtl.disableLimits();
                isOrbiting = true;
            }
        }
    });

    const disableCameraOrbitTempIfActive = () => {
        if (cameraOrbitTempActive) {
            cameraOrbitTempActive = false;
            controlsOrbit.enabled = false;
            controlsObjRot.enabled = true;
            LimitsCtl.reEnableLimits(Q3.SlideManager.activeSlide);
        }
    };

    document.addEventListener("keyup", event => {
        if (LimitsCtl.isControlEvent(event) && isOrbiting) {
            disableCameraOrbitTempIfActive();
            isOrbiting = false;
        }
    });

    const disableCameraOrbitTempIfNoAlt = event => {
        if (!event.ctrlKey) {
            disableCameraOrbitTempIfActive();
        }
    };

    document.addEventListener("mousedown", disableCameraOrbitTempIfNoAlt);
    document.addEventListener("mouseup", disableCameraOrbitTempIfNoAlt);
    document.addEventListener("mousemove", disableCameraOrbitTempIfNoAlt);
}

function isCameraOrbitTempActive() {
    return cameraOrbitTempActive;
}

export default initCameraOrbitToggle;
export { initCameraOrbitToggle, isCameraOrbitTempActive };
